import React from "react";
import { useSelector } from "react-redux";
import AgencyDocuments from "./agency";
import FreelancerDocuments from "./freelancer";

function DocumentsPage() {
  const user = useSelector((state) => state.user || {});
  const isAgency = user?.isAgency ?? false;
  return <>{isAgency ? <AgencyDocuments /> : <FreelancerDocuments />}</>;
}

export default DocumentsPage;
